import { Select, SelectTrigger, SelectValue, SelectPopup, SelectItem } from '@w/ui/components/select'

export function Filter(props: {
  label: string
  value?: string
  values: string[]
  onChange: (value: string) => void
}) {
  return (
    <label className="flex w-28 max-w-full select-none flex-col gap-2 text-sm font-medium">
      {props.label}
      <Select value={props.value ?? 'all'} onValueChange={value => { if (value !== null) props.onChange(value) }}>
        <SelectTrigger aria-label={props.label} data-testid={`${props.label.toLowerCase()}-filter`}>
          <SelectValue>{!props.value || props.value === 'all' ? 'All' : props.value}</SelectValue>
        </SelectTrigger>
        <SelectPopup align="start">
          <SelectItem data-testid={`${props.label.toLowerCase()}-option-all`} value="all">All</SelectItem>
          {props.values.map(value => <SelectItem key={value} data-testid={`${props.label.toLowerCase()}-option-${value}`} value={value}>{value}</SelectItem>)}
        </SelectPopup>
      </Select>
    </label>
  )
}
